//@flow

import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import makeUrl from '../../lib/makeUrl';
import FormState from '../../components/Login/FormState';
import GoogleLogin from '../../components/Login/GoogleLogin';
import { HG_EMAIL } from '../../constants/email';
import FacebookLogin from '../../components/Login/FacebookLogin';

type Props = {
  registerAccount: Function,
  loading: boolean,
  serverError: string,
  dispatch: Function,
  isUserLoggedIn: boolean,
  sendInfoToBackend: Function,
};

export default class CreateAccount extends Component<Props> {
  componentDidMount() {
    if (this.props.isUserLoggedIn) this.callApi();
  }

  callApi = async () => await this.props.sendInfoToBackend();

  render() {
    const { registerAccount, loading, serverError, dispatch, isUserLoggedIn } = this.props;
    const authProps = { submit: registerAccount, loading };

    return (
      <div className="travel-dates-options">
        {isUserLoggedIn ? (
          <div className="message-box text-center">
            <h3>Thank you!</h3>
            <p>
              For choosing <strong>HoneyGuide</strong> to help you with your trek planning.
              We will get back to you with the best trek recommendations within 24 hours!
              Until then, you can also view our existing trek itineraries. For further
              assistance, You can also reach Dakshina at:{' '}
              <a href={`mailto:${HG_EMAIL}<`}>{HG_EMAIL}</a>.
            </p>
            <Link to={makeUrl.goToTreks}>
              <Button color="yellow" s>
                Show me Treks!
              </Button>
            </Link>
          </div>
        ) : (
          <Fragment>
            <FacebookLogin {...authProps} />
            <GoogleLogin {...authProps} />
            <FormState {...authProps} />
            {serverError}
            <div className="text-center mt-4">
              <Button
                color="yellow"
                onClick={() => dispatch({ type: 'DECREMENT', key: 'step' })}
              >
                Back
              </Button>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/OnboardingForm/CreateAccount.jsx